Whether the cover image from the provided `AdvertisementBranding` will be visible on the job ad.
